import React, { useState } from "react";
import axios from "axios";
import "./ForecastForm.css"; // Import the CSS file

const ForecastForm = () => {
  const [formData, setFormData] = useState({
    startDate: "",
    endDate: "",
    months: "",
    weight_lstm: "",
    weight_bilstm: "",
    weight_arima: "",
    weight_sarima: "",
    wellId: "",
  });

  const [forecastResult, setForecastResult] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setForecastResult([]);
    setIsLoading(true);
  
    try {
      const response = await axios.post("https://warpo-dashboard.cse.buet.ac.bd/api/api/forecast", formData);
  
      if (response?.data?.data?.datalogs && Array.isArray(response.data.data.datalogs)) {
        // Map the datalogs to extract 'date' and 'wtr' fields only
        const formattedData = response.data.data.datalogs.map(entry => ({
          date: entry.mTm,
          wtr: entry.wtr,
        }));
        setForecastResult(formattedData);
      } else {
        setErrorMessage("Invalid forecast data format received.");
      }
    } catch (error) {
      console.error(error);
      setErrorMessage("Failed to fetch forecast data.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forecast-form-container">
      <form onSubmit={handleSubmit} className="forecast-form">

        {/* Dates Row */}
        <div className="form-row">
          <div className="form-group">
            <label>Start Date</label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>End Date</label>
            <input
              type="date"
              name="endDate"
              value={formData.endDate}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* Months & Well ID Row */}
        <div className="form-row">
          <div className="form-group">
            <label>Months</label>
            <input
              type="number"
              name="months"
              value={formData.months}
              onChange={handleChange}
              placeholder="Enter number of months"
              required
            />
          </div>
          <div className="form-group">
            <label>Well ID</label>
            <input
              type="text"
              name="wellId"
              value={formData.wellId}
              onChange={handleChange}
              placeholder="Enter Well ID"
              required
            />
          </div>
        </div>

        {/* Weights Row */}
        <div className="form-row">
          <div className="form-group">
            <label>LSTM Weight</label>
            <input
              type="text"
              name="weight_lstm"
              value={formData.weight_lstm}
              onChange={handleChange}
              placeholder="e.g., 0.25"
              required
            />
          </div>
          <div className="form-group">
            <label>BiLSTM Weight</label>
            <input
              type="text"
              name="weight_bilstm"
              value={formData.weight_bilstm}
              onChange={handleChange}
              placeholder="e.g., 0.25"
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>ARIMA Weight</label>
            <input
              type="text"
              name="weight_arima"
              value={formData.weight_arima}
              onChange={handleChange}
              placeholder="e.g., 0.25"
              required
            />
          </div>
          <div className="form-group">
            <label>SARIMA Weight</label>
            <input
              type="text"
              name="weight_sarima"
              value={formData.weight_sarima}
              onChange={handleChange}
              placeholder="e.g., 0.25"
              required
            />
          </div>
        </div>

        {/* Submit Button */}
        <div className="form-row">
          <button type="submit" className="submit-button" disabled={isLoading}>
            {isLoading ? "Forecasting..." : "Get Forecast"}
          </button>
        </div>
      </form>

      {/* Loading Animation */}
      {isLoading && (
        <div className="loading-message">
          <div className="spinner"></div>
          <p className="loading-text">Please hang on... Forecasting in progress ⏳</p>
        </div>
      )}

      {/* Error Message */}
      {errorMessage && <p className="error-message">{errorMessage}</p>}

      {/* Forecast Result */}
      {!isLoading && forecastResult.length > 0 && (
        <div className="forecast-result">
          <h3>Forecast Result:</h3>
          <table className="forecast-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>WTR</th>
              </tr>
            </thead>
            <tbody>
              {forecastResult.map((entry, index) => (
                <tr key={index}>
                  <td>{entry.date}</td>
                  <td>{entry.wtr}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ForecastForm;
